import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {getAccountById} from '../../../../selectors/Ares/selectors';
import {isNullOrUndefined, labels} from '../../../../util/utils';
import {getInUserNumberFormat} from './AccountSummaryConfig';
import EllipsesControl from '../../EllipsesControl/EllipsesControl';
import {useUserPreferences} from '../../../../util/customHooks';

function CurrentYearBalance({className, accountId}) {
	const {currentBalance} = useSelector((state) => getAccountById(state, accountId)) || {};
	const userPreferences = useUserPreferences();

	const currentPeriodBalance = getInUserNumberFormat(currentBalance, userPreferences);

	return (
		<StyledCurrentYearBalanceSection className={`StyledCurrentYearBalanceSection ${className}`}>
			<>
				{!isNullOrUndefined(currentBalance) ? (
					<span className="text-renderer">
						<EllipsesControl noOfLines={1} content={currentPeriodBalance} tooltip={currentPeriodBalance} />
					</span>
				) : (
					<span className="text-renderer">{labels.notAvailable}</span>
				)}
			</>
		</StyledCurrentYearBalanceSection>
	);
}

CurrentYearBalance.propTypes = {
	className: PropTypes.string,
	accountId: PropTypes.number.isRequired
};

CurrentYearBalance.defaultProps = {
	className: 'currentyear-cellrenderer'
};

export default CurrentYearBalance;

const StyledCurrentYearBalanceSection = styled.section`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
	font-size: var(--px-12);
	font-weight: 400;
	line-height: var(--px-22);
	padding-right: var(--px-5);
	.text-renderer {
		font-size: var(--px-12);
		font-weight: 400;
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: auto;
		max-width: var(--px-90);
	}
`;
